import React from "react";
import PropTypes from "prop-types";
import { getEndpoint, NPS_DEFAULT_ENDPOINT } from "../../../services/commons";
import AnswerScaleNps from "../AnswerScaleNps";
import { NPS_TITLE } from "../../constants";
import { useTranslation } from "react-i18next";
import { getTranslation } from "../../../locales";

const AnswerNps = (props) => {
  const { t } = useTranslation("surveyTaker");

  return (
    <AnswerScaleNps
      handleChange={props.handleChange}
      choices={[
        { value: "0", label: t("surveyTaker:notAtAllLikely") },
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" },
        { value: "7" },
        { value: "8" },
        { value: "9" },
        { value: "10", label: t("surveyTaker:extremelyLikely") },
      ]}
      value={props.value}
      question={
        props.npsTitle
          ? props.npsTitle
          : `${t(NPS_TITLE)} ${props.subject || t("surveyTaker:npsScale")} ${
              props.recommendTo
            }`
      }
      required={props.required}
      helperText={props.helperText}
      endpointLow={getTranslation(
        props.currentLang,
        getEndpoint(NPS_DEFAULT_ENDPOINT, "left")
      )}
      endpointHigh={getTranslation(
        props.currentLang,
        getEndpoint(NPS_DEFAULT_ENDPOINT, "right")
      )}
      currentTheme={props.currentTheme}
    />
  );
};

AnswerNps.propTypes = {
  subject: PropTypes.string.isRequired,
  currentTheme: PropTypes.object.isRequired,
  required: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  recommendTo: PropTypes.string,
  helperText: PropTypes.string,
};

AnswerNps.defaultProps = {
  required: false,
};

export default AnswerNps;
